import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
let ContinueBlinkingProcessComponent = class ContinueBlinkingProcessComponent {
    constructor(httpClient, router, themeService, sanitizer) {
        this.httpClient = httpClient;
        this.router = router;
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.userTypeLiteVerified = 'lite_verified';
        this.blinkingAvailable = new EventEmitter();
        this.blinkingUrl = new EventEmitter();
        this.goToPersonalVerification = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
        if (this.userType === this.userTypeLiteVerified) {
            this.dontShowVerifyPageOnLogin();
        }
    }
    goToContactPage(event) {
        if (event.target.tagName === 'A') {
            event.preventDefault();
            this.router.navigateByUrl('/contact');
        }
    }
    goToBlinking() {
        if (this.shouldGoToPersonalVerification) {
            this.goToPersonalVerification.emit(true);
        }
        else {
            this.httpClient.post('blinking/initiateProcess', { languageCode: this.lang }).subscribe((data) => {
                this.blinkingUrl.emit(data['url']);
            }, (error) => {
                this.blinkingAvailable.emit(false);
            });
        }
    }
    goToExchange() {
        this.router.navigateByUrl('/');
    }
    dontShowVerifyPageOnLogin() {
        this.httpClient.post('user/dontshowverifypageonlogin', {}).subscribe();
    }
};
ContinueBlinkingProcessComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: WebsiteThemeService },
    { type: DomSanitizer }
];
__decorate([
    Input()
], ContinueBlinkingProcessComponent.prototype, "userType", void 0);
__decorate([
    Input()
], ContinueBlinkingProcessComponent.prototype, "lang", void 0);
__decorate([
    Input()
], ContinueBlinkingProcessComponent.prototype, "shouldGoToPersonalVerification", void 0);
__decorate([
    Output()
], ContinueBlinkingProcessComponent.prototype, "blinkingAvailable", void 0);
__decorate([
    Output()
], ContinueBlinkingProcessComponent.prototype, "blinkingUrl", void 0);
__decorate([
    Output()
], ContinueBlinkingProcessComponent.prototype, "goToPersonalVerification", void 0);
ContinueBlinkingProcessComponent = __decorate([
    Component({
        selector: 'ecd-continue-blinking-process',
        template: __importDefault(require("./continue-blinking-process.component.html")).default,
    })
], ContinueBlinkingProcessComponent);
export { ContinueBlinkingProcessComponent };
